import axios from 'axios';
import { isJwtExpiredByDailyMidnight } from './jwtDailyExpiry';

const AGENT_PORTAL_TOKEN_KEY = 'ipe_agent_portal_token';
const AGENT_PORTAL_ROLE_KEY = 'ipe_agent_portal_role';

const agentPortalApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

agentPortalApi.interceptors.request.use((config) => {
  const token = getAgentPortalToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

agentPortalApi.interceptors.response.use(
  (response) => {
    const body = response.data;
    if (body && body.code === 200) {
      return body.data;
    }
    return Promise.reject(new Error(body?.message || '请求失败'));
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(AGENT_PORTAL_TOKEN_KEY);
      localStorage.removeItem(AGENT_PORTAL_ROLE_KEY);
      if (typeof window !== 'undefined' && !window.location.pathname.includes('/ipe/agent/login')) {
        window.location.href = '/ipe/agent/login';
      }
    }
    const body = error.response?.data;
    const msg = body?.message || body?.error || error.message || '请求失败';
    return Promise.reject(new Error(msg));
  }
);

export function getAgentPortalToken() {
  const token = localStorage.getItem(AGENT_PORTAL_TOKEN_KEY);
  const trimmed = token && String(token).trim() ? String(token).trim() : null;
  if (!trimmed) return null;
  if (isJwtExpiredByDailyMidnight(trimmed)) {
    setAgentPortalToken(null);
    return null;
  }
  return trimmed;
}

export function setAgentPortalToken(token) {
  if (token) {
    localStorage.setItem(AGENT_PORTAL_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(AGENT_PORTAL_TOKEN_KEY);
    localStorage.removeItem(AGENT_PORTAL_ROLE_KEY);
  }
}

export function getAgentPortalRole() {
  return localStorage.getItem(AGENT_PORTAL_ROLE_KEY);
}

export function setAgentPortalSession(role) {
  if (role) {
    localStorage.setItem(AGENT_PORTAL_ROLE_KEY, role);
  } else {
    localStorage.removeItem(AGENT_PORTAL_ROLE_KEY);
  }
}

export const agentPortalAPI = {
  login: (phone, password, captchaToken) => agentPortalApi.post('/agent-portal/auth/login', { phone, password, captchaToken }),
  getMe: () => agentPortalApi.get('/agent-portal/auth/me'),
  getLlmModels: () => agentPortalApi.get('/agent-portal/llm/models'),
  rechargeModelQuota: (payload) => agentPortalApi.post('/agent-portal/llm/models/recharge', payload),
  adjustModelConsumed: (payload) => agentPortalApi.post('/agent-portal/llm/models/consumed', payload),
  getLlmDashboard: () => agentPortalApi.get('/agent-portal/llm/dashboard'),
  getLlmLogs: (params) => agentPortalApi.get('/agent-portal/llm/logs', { params }),
  getIntegrations: () => agentPortalApi.get('/agent-portal/integrations'),
  rechargeIntegration: (payload) => agentPortalApi.post('/agent-portal/integrations/recharge', payload),
  getTasksDashboard: (params) => agentPortalApi.get('/agent-portal/tasks/dashboard', { params }),
  getTasks: (params) => agentPortalApi.get('/agent-portal/tasks', { params }),
  getTaskDetail: (id) => agentPortalApi.get(`/agent-portal/tasks/${id}`),
  retryTask: (id) => agentPortalApi.post(`/agent-portal/tasks/${id}/retry`),
  getSystemLogs: (params) => agentPortalApi.get('/agent-portal/system/logs', { params }),
  getSidecarDashboard: () => agentPortalApi.get('/agent-portal/sidecar-apis/dashboard'),
  getSidecarLogs: (params) => agentPortalApi.get('/agent-portal/sidecar-apis/logs', { params }),
  getSidecarLogDetail: (id) => agentPortalApi.get(`/agent-portal/sidecar-apis/logs/${id}`),
};

export default agentPortalAPI;
